import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import {Button, Card, CardText} from "react-md";
import {map, isEmpty, forEach, size} from "lodash";

import Carousel from "../../Carousel";
import AtollonLogo from "../../../assets/img/atollon-logo-black.png";
import {TouchOrganizations} from "../../../Atollon/Organizations";
import {TouchTableHeader} from "../../../AtollonTheme/ReactElements";
import { setDialog } from "../../../actions/dialogActions";

const Organizations = ({ history, data, setDialog }) => {
  return data && !isEmpty(data.item) ? (
    <div className="">

        <TouchTableHeader
            title={"Organizace, ve kterých jsem správcem"}
            titleNumber={data && !isEmpty( data.item ) ? size( data.item ) : null}
        />

        <TouchOrganizations
            gotoAdminPage={true}
            organizationArray={data.item}
            history={history}
        />
    </div>
  ) : (
    <div />
  );
};

export default Organizations;
/*
export default compose(
    connect(
        state => ({state}),
        {
          setDialog
        }
    )
)(Organizations);
*/


// WEBPACK FOOTER //
// ./src/components/settings/organizations/OrgAdmin.js